import { useQuery } from '@tanstack/react-query'
import { WhatsNewItem } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { whatsNewKeys } from './query-keys'

interface WhatsNewListResult {
  results: WhatsNewItem[]
  total: number
  maxItems: number
}

const fetchWhatsNewList = async (): Promise<WhatsNewListResult> => {
  try {
    const res = await AppAdmin.getWhatsNewList()
    const payload = res.data?.data
    return {
      results: payload?.results ?? [],
      total: payload?.total ?? 0,
      maxItems: payload?.maxItems ?? 10,
    }
  } catch (error) {
    logError('Error fetching whats new list:', error)
    return { results: [], total: 0, maxItems: 10 }
  }
}

export const useWhatsNewList = () => {
  const query = useQuery({
    queryKey: whatsNewKeys.list(),
    queryFn: fetchWhatsNewList,
    gcTime: 30000,
  })

  return {
    items: query.data?.results ?? [],
    total: query.data?.total ?? 0,
    maxItems: query.data?.maxItems ?? 10,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetch: query.refetch,
  }
}
